var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"software",attrs:{"oncontextmenu":"return false"}},[_c('layer'),_vm._v(" "),_c('sdata'),_vm._v(" "),_c('crm'),_vm._v(" "),_c('function'),_vm._v(" "),_c('foot'),_vm._v(" "),_c('Isoftware',{staticClass:"phsoft"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e761b0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/software/software.vue
// module id = null
// module chunks = 